import { useContext } from 'react';

import { useMediaQuery } from '@skyscanner/backpack-web/bpk-component-breakpoint';

import { getMatchSSR } from '@shared/utils-frontend/breakpoint';
import UserContext from '@shared/utils-frontend/contexts/UserContext';

/**
 * Hook that wraps Backpack's useMediaQuery with automatic SSR device detection.
 *
 * @param {string} query - Media query string or BREAKPOINTS constant
 * @returns {boolean} Whether the media query matches
 *
 * @example
 * ```tsx
 * import { useBreakpoint, BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
 *
 * const MyComponent = () => {
 *   const isMobile = useBreakpoint(BREAKPOINTS.MOBILE);
 *   return isMobile ? <MobileView /> : <DesktopView />;
 * };
 * ```
 */
export const useBreakpoint = (query: string): boolean => {
  const userContext = useContext(UserContext);
  const matchSSR = getMatchSSR(query, userContext);

  return useMediaQuery(query, matchSSR);
};
